import styled from 'styled-components';
import { ChevronRightNew16 } from 'ui/icons';
import { body2, caption as captionStyles, colors, overline, spacing } from 'ui/theme';
import noop from 'utils/noop';

import { AlertHistoryListItem } from './AlertHistory.styled';

export const HistoryTitle = styled.div`
  ${overline}
  margin-bottom: ${spacing.threeQuarter};
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  flex: 1;
`;

export const Label = styled.span`
  ${body2};
`;

export const Caption = styled.span`
  ${captionStyles}
  color: ${colors.textSecondary};
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type AlertHistoryItemProps = {
  hoverable?: boolean;
  label: React.ReactNode;
  caption: React.ReactNode;
  setSelectedAlert?: () => void;
};

export const AlertHistoryItem = ({
  label,
  caption,
  hoverable = true,
  setSelectedAlert = noop,
  ...rest
}: AlertHistoryItemProps) => {
  return (
    <AlertHistoryListItem onClick={setSelectedAlert} $hoverable={hoverable} {...rest}>
      <Left>
        <Label>{label}</Label>
        <Caption>{caption}</Caption>
      </Left>

      <Right>
        <ChevronRightNew16 color={colors.iconPrimary} />
      </Right>
    </AlertHistoryListItem>
  );
};
